module.exports = __webpack_public_path__ + "img/Number=97.acccfaac.png";